import { render, staticRenderFns } from "./ChevronIcon.vue?vue&type=template&id=e06e31e4&"
import script from "./ChevronIcon.vue?vue&type=script&lang=js&"
export * from "./ChevronIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports